import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import WhatWeBuild from "@/components/site/WhatWeBuild";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Work from "@/components/site/Work";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyCta from "@/components/site/StickyCta";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const tick = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      setTimeout(tick, 80);
    } else {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [location.hash]);

  return (
    <main className="bg-[#FDFCFB] text-[#1A1A1A]">
      <Nav />
      <Hero />
      <WhatWeBuild />
      <Services />
      <Process />
      <Work />
      <Testimonials />
      <Contact />
      <Footer />
      <StickyCta />
    </main>
  );
}
